import { useState, useEffect } from "react";
import H2 from "@/atoms/text/H2";
import Image from "@/atoms/Image";
import AudioStrip from "@/molecules/AudioStrip";
import { isMobileScreen } from "@/utils/functions";
import useIntersectionObserver from "@/utils/useIntersectionObserver";

const AudioLayout = ({
  title,
  color,
  className,
  image,
  isLPvariant = false,
  isV2AnsweringService = false,
}) => {
  const [isMobile, setIsMobile] = useState(null);
  useEffect(() => {
    setIsMobile(isMobileScreen);
    if (!isMobileScreen()) {
      const heroElement = document.querySelector(".hero");
      const articleElement = document.querySelector(".hero article");

      if (heroElement && isLPvariant) {
        heroElement.style.setProperty(
          "height",
          "calc(100vh + 110px)",
          "important"
        );
      }
      if (articleElement && isLPvariant) {
        articleElement.style.position = "relative";
        articleElement.style.bottom = "60px";
      }
    }
  }, [isLPvariant]);

  const { elementRef, isIntersecting } = useIntersectionObserver({
    threshold: 0.1,
  });

  return (
    <section
      data-testid="audio-layout"
      className={`${className} ${
        isLPvariant
          ? isMobile
            ? "pt-8 bc-black"
            : `lp-variant ${
                isV2AnsweringService ? "bc-blue-light " : "bc-white"
              }`
          : "bc-grad-blue"
      } ${!isLPvariant ? "pt-7-d pt-8" : ""}`}
      ref={elementRef}
    >
      <div
        className={`${
          isLPvariant && !isMobile ? "bc-black ps-r br-16" : ""
        } container`}
      >
        <div
          className={`fx fx--r-d fx--sb fx--cv-d fx--c ${
            isLPvariant && !isMobile ? "lp-variant-wrapper" : ""
          }`}
        >
          {title && (
            <H2
              color={color}
              className={`${
                isLPvariant && !isMobile ? "" : "mb-7-d mb-5"
              } bold`}
              dangerouslySetInnerHTML={{
                __html: `${title}<span class="dot">.</span>`,
              }}
            ></H2>
          )}
          <div
            className={`audio-player fx fx--c fx--order-1-d ${
              isLPvariant && !isMobile ? "" : "mb-7"
            }`}
          >
            <AudioStrip
              audioInfoColor={`${isLPvariant ? "#61CEFC" : "#FFF"}`}
              audioFile="https://assets.answerforce.com/answerforce/us/website/media/af-roofing-audio.mp3"
              audioWaveTimeLineColor={`${
                isLPvariant ? "#E2E2E750" : "#8bb8e0"
              }`}
            />
          </div>
          {isIntersecting && (
            <Image
              fileName={image.fileName}
              fileFormat="png"
              desktopWidth={image.desktopWidth}
              mobileWidth={image.mobileWidth}
              mobileHeight={image.mobileHeight}
              alt={image.altName}
            />
          )}
        </div>
      </div>
      <style jsx>{`
        .audio-player {
          max-width: 386px;
        }
        @media (max-width: 768px) {
          .audio-player {
            max-width: 332px;
          }
        }
        .lp-variant {
          max-height: 110px;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            height: 100px;
            background: transparent;
          }
          & .container {
          top: -110px;
          // clip-path: inset(-70px 0px 0px 0px);
          }
        .lp-variant-wrapper {
          height: 220px;
          padding: 60px;

           figure picture img {
           width: 270px;
           position: relative;
           bottom: 25px;
          }
         }
       
      `}</style>
    </section>
  );
};

AudioLayout.defaultProps = {
  className: "",
  color: "white",
};

export default AudioLayout;
